import './project-item.scss';
import { ProjectModel } from "../../../models/Project";
import { useNavigate } from 'react-router-dom';
import { RouterName } from '../../../enum/RouterEnum';
import SwipeComponent from '../swipe';
import { useSwiperSlide } from 'swiper/react';
import { useEffect, useRef } from 'react';
import { SentenceScramble } from '../../../ultils/SentenceScramble';

interface Props {
  height: number,
  project: ProjectModel;
  index: number;
  handlePrevStep: () => void;
  handleNextStep: () => void;
  goToDetail: () => void;
  realIndex: number | null;
}

const ProjectMobileItem = (props: Props) => {
  const { height, project, index, goToDetail } = props;
  const navigate = useNavigate();
  const swiperSlide = useSwiperSlide();
  const hasScrambledOnce = useRef(false); // persists across renders

  useEffect(() => {
    if (swiperSlide.isActive && !hasScrambledOnce.current) {
      const sentenceScrambler = new SentenceScramble(`project-${index}-scrambler`, () => {}, true);
      sentenceScrambler.startScramble(0.66, 0);
      // sentenceScrambler.startSequentialScramble(0.25);
      hasScrambledOnce.current = true;
    }
  }, [swiperSlide?.isActive]);

  const _changeShowDetail = () => {
    let charExits = /\W/g;
    const path = project.title.replaceAll(" ", "_").replace(charExits, '');
    navigate(`${RouterName.projectDetail}/${path}`, {
      state: project
    })
  };

  return (
    <>
      <div className="header-slide-container" style={{ ["--window-height" as string]: `${height}px` }}>
        <p className={`text-title-mobile`}>CLIENT</p>
        <p className={`text-title-desc-mobile project-${index}-scrambler`}>{project.title}</p>
        <p className={`text-detail-mobile`}>EXPERIMENT</p>
        <p className={`text-detail-desc-mobile project-${index}-scrambler`}>{project.detailTitle}</p>
      </div>
      <div className={'project-list-home'}>
        <div className="projects-list-mobile-container">
          <div className='project-mobile-container' onClick={() => _changeShowDetail()}>
            <div className='project-mobile-border'></div>
            <div className='image-project-mobile'>
              <video
                autoPlay
                loop muted
                playsInline
                src={project.image}
              />
            </div>
          </div>
        </div>
        <SwipeComponent goToDetail={goToDetail}></SwipeComponent>
      </div>
    </>
  )


};

export default ProjectMobileItem;
